// The game version players see (docs/deploy/releases.md): "Alpha 0.1.0" on a release,
// "Alpha 0.1.0+5.abc1234" on a staging build five commits later.

export const VERSION_LABEL = `Alpha ${__APP_VERSION__}`;
